import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../SubscriptionOptions/SubscriptionOptions.css";
import { cancelSubscription, validateCoupon } from "../../api/password";
import { getPublicPlans } from "../../api/Stripe";
import goBackButton from "../../assets/images/Go_Back.svg";
import { notification, Col, Input, Row, Spin } from "antd";

const SubscriptionOptions2 = ({
  title,
  desc,
  pkg,
  price,
  extra,
  details,
  detail,
  isSelected,
  onClick,
}) => (
  <div 
    className={`height-450px subscription-option ${isSelected ? "selected" : ""}`}
    onClick={onClick}
  >
    <Row className="heading-description-container">
      <h2 className="text-align-center" style={{ display: "block" }}>
        {title}
      </h2>
      <div className="desc">
        {desc.map((desc, index) => (
          <p className="lh-24" key={index}>{desc}</p>
        ))}
      </div>
    </Row>
    <Row className="price-container">
      <div className="plan">
        <p className="pkg">{pkg}</p>
        <span className="price">&nbsp;{price}</span>
      </div>

      <div className="text-align-center">
        <span className="extra">{extra}</span>
      </div>

      <div>
        <ul className="details mt-0">
          {details.map((details, index) => (
            <li className="lh-18"  key={index}>{details}</li>
          ))}
        </ul>
      </div>
    </Row>
    <button className={`confirm-button ${isSelected ? "confirmed" : ""}`}>
      {isSelected ? "Selected" : "Confirm"}
    </button>
    <Row style={{ height: "auto" }}>
      <div className="detail">
        {detail.map((detail, index) => (
          <p key={index}>{detail}</p>
        ))}
      </div>
    </Row>
  </div>
);

const SubscriptionOption2 = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const subscriptionId = location.state?.subscriptionId;
  const subscriptionDetails = location?.state?.subscriptionDetails;
  const planName = subscriptionDetails?.planName?.planName;
  const subscriptionStatus = subscriptionDetails?.planName?.status;
  const [couponCode, setCouponCode] = useState('');

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    try {
      setLoading(true);
      const response = await getPublicPlans();
      console.log('API Response:', response);
      if (response && response.data && response.data.subscriptionPlans) {
        console.log('Plans fetched:', response.data.subscriptionPlans);
        setPlans(response.data.subscriptionPlans);
      }
    } catch (error) {
      console.error('Error fetching plans:', error);
      notification.error({
        message: 'Error',
        description: 'Failed to load subscription plans. Using default prices.',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = (option) => {
    setSelectedOption(option);
  };

  const handleNext = async () => {

    let couponResponse = null;

    if (couponCode) {
      try {
        const response = await validateCoupon({ discountCode: couponCode });
        if (response.error) {
          notification.error({ message: 'Coupon Validation Error', description: response.error, duration: 10 });
          return;
        } else {
          notification.success({ message: 'Coupon Validated', description: response.message, duration: 10 });
          couponResponse = response;
        }
      } catch (error) {
        notification.error({ message: 'Coupon Validation Error', description: error.message, duration: 10 });
        return;
      }
    }

    if (selectedOption) {
      navigate("/confirm-subs2", {
        state: { selectedOption, subscriptionId: subscriptionId, subscriptionDetails: subscriptionDetails, couponResponse: couponResponse },
      });
    } else {
       notification.warning({
        message: 'Selection Required',
        description: 'Please select a subscription option.',
        duration: 10
      });
      return;
    }
  };

  const handleCancelSubscription = async () => {
    try {
      const response = await cancelSubscription();
      if (response.error) {
        notification.error({ message: 'Cancel Subscription Error', description: response.error, duration: 10 });
      } else {
        notification.success({ message: 'Subscription Canceled', description: 'Your subscription has been canceled successfully.', duration: 10 });
      }
    } catch (error) {
      notification.error({ message: 'Cancel Subscription Error', description: error.message, duration: 10 });
    }
  };

  const handleGoBackButton = () => {
    navigate("/manage-sub");
  };

  const getFilteredOptions = (planName, subscriptionStatus) => {
    // Find monthly and annual plan prices from fetched data
    const monthlyPlan = plans.find(p => p.interval === 'month');
    const annualPlan = plans.find(p => p.interval === 'year');
    
    console.log('Monthly plan:', monthlyPlan);
    console.log('Annual plan:', annualPlan);

    const options = [
      {
        title: "Pay Monthly",
        pkg: `£${monthlyPlan?.price?.toFixed(2) || '7.29'}`,
        price: "/month ",
        extra: "+ 30p transaction charge",
        desc: ["Access to all our features for free for the first month, then:"],
        details: [],
        buttonText: "Confirm",
        detail: [
          "*Your subscription will automatically renew, but you can cancel at any time. You must give one month's notice before your subscription is cancelled. The monthly price is subject to change.",
        ],
        stripePlanId: monthlyPlan?.stripePlanId, // Add the actual stripePlanId from API
        planId: monthlyPlan?.id, // Add database plan ID
      },
      {
        title: "Pay Annually",
        pkg: `£${annualPlan?.price?.toFixed(2) || '69.90'}`,
        price: "/year ",
        extra: "",
        desc: ["Get 12 months for the price of 10.", "No transaction fee."],
        details: ["No transaction fee."],
        buttonText: "Confirm",
        detail: [
          "*Cancel at any time, but you must have given one month's notice before your subscription is cancelled. The annual price is subject to change.",
        ],
        stripePlanId: annualPlan?.stripePlanId, // Add the actual stripePlanId from API
        planId: annualPlan?.id, // Add database plan ID
      },
    ];

    return options.filter((option) => {
      if (planName === "free") {
        return true;
      } else if (planName === "Monthly Plan" && subscriptionStatus !== "canceled") {
        return option.title === "Pay Annually";
      } else if (planName === "Yearly Plan" && subscriptionStatus !== "canceled") {
        return option.title === "Pay Monthly";
      } else {
        return true;
      }
    });
  };

  const filteredOptions = getFilteredOptions(planName, subscriptionStatus);

  return (
    <div>
      <Row gutter={24}>
        <Col >
          <button onClick={handleGoBackButton} className="button-styling">
            <img src={goBackButton} alt="Go Back Button" />
          </button>
        </Col>
      </Row>
      
      <Row className="welcome-onboarding-row">
        <Row gutter={24} className="chose-subscription-text-container">
          <Col span={24}>
            <span
              className="heading text-align-center"
              style={{ display: "block" }}
            >
              Choose Your Subscription
            </span>
          </Col>
        </Row>

        <Row gutter={24} className="chose-subscription-text-container">
          <Col className="flex-justify-center">
            <span className="text chose-subscription-description-text">
              Please select the payment option that best suits your needs. All
              options will take you directly to the secure payment provider
              platform. We have selected to use Stripe as our provider to ensure
              secure and efficient online protection of your data.
            </span>
          </Col>
        </Row>

        <div className="subscription-options-container">
          <Row gutter={12} className="justify-content-center flex-justify-space-center">
            {filteredOptions?.map((option, index) => (
              <Col key={index} xs={24} sm={24} md={8} lg={7}>
                <SubscriptionOptions2
                  {...option}
                  isSelected={selectedOption?.title === option.title}
                  onClick={() => handleConfirm(option)}
                  onConfirm={() => handleConfirm(option)}
                />
              </Col>
            ))}
          </Row>
          <Row className="coupon-code">
            <Col span={24}>
              <Input
                placeholder="Enter Coupon Code (Optional)"
                value={couponCode}
                className='coupon-code-input'
                onChange={(e) => setCouponCode(e.target.value)}/>
            </Col>
          </Row>

          <Row className="flex-justify-space-around">
            <button className="next-button-1" onClick={handleNext}>
              Next
            </button>
          </Row>
        </div>
      </Row>
    </div>
  );
};

export default SubscriptionOption2;